export const create = {
  createSuccessfully: 'Create new customer successfully!',
}
